import { contracts, partners } from '../../../services/api.admin';
import { permitContractBody } from './contracts';
import { fetchDependencies, submit } from '../modal.forms';
import { findIndex, filter } from 'lodash';
import { MODELS } from '../../../constants/admin/settings';
import { formDataSelector } from '../../../selectors/admin/models/contracts';
import { onInput } from '../forms';
import { ADMIN_MODAL_FORMS } from '../../../constants/actions';
import { selectedSelector } from '../../../selectors/admin/tables';
import { refresh } from '../tables';
import { v4 as uuidv4 } from 'uuid';

export function fetchContractPartnerDependencies(_c, eventId) {
    return fetchDependencies([() => partners.getAllForEvent(eventId)]);
}

export function updateContractPartners(data) {
    return (dispatch, getState) => {
        const contractForm = formDataSelector(getState());
        const { clearing, id } = contractForm;
        let newClearing = [...clearing];
        if (!data) {
            // DELETE
            const selected = selectedSelector(getState());
            newClearing = filter(newClearing, x => !selected.includes(x.id));
        } else if (data.id) {
            // UPDATE
            const index = findIndex(clearing, c => c.id === data.id);
            newClearing[index] = data;
        } else {
            // ADD
            newClearing.push({ ...data, id: uuidv4() });
        }
        dispatch(onInput(MODELS.CONTRACT, 'clearing', newClearing));
        dispatch(refresh());
        if (id) {
            return submit(() => contracts.put(id, permitContractBody({ ...contractForm, clearing: newClearing })))(
                dispatch,
                getState
            );
        } else {
            return dispatch({ type: ADMIN_MODAL_FORMS.SUCCESS });
        }
    };
}

// const _permitBody = (data, extraFields = []) =>
//     pick(data, ['live', 'nonLinear', 'partnerId', 'comments', 'useUntil'].concat(extraFields));



// WEBPACK FOOTER //
// ./src/actions/admin/models/contract.partners.js